import { Container } from "components/LandingPage/Container";

import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

const faqs = [
  {
    question: "What is myJson and how does it work?",
    answer:
      "myJson is a JSON storage API service that allows developers to store, manage, and version JSON data through simple REST API calls. You can create collections, store JSON objects, and perform CRUD operations without setting up any infrastructure. It's perfect for prototyping, CMS systems, IoT applications, and web dashboards.",
  },
  {
    question: "How much does myJson cost?",
    answer: 
      "myJson offers a free tier with 500 credits to get started. After that, you pay only for what you use at 1 credit per API request. Plans start at $9 for 25,000 credits. There are no subscription fees or hidden costs - you only pay for the API calls you make.",
  },
  {
    question: "Is my data secure and private?",
    answer: 
      "Yes, your data is completely secure. We offer private collections protected with API keys, ensuring only you can access your data.",
  },
  {
    question: "What is versioning and how does it work?",
    answer: 
      "Versioning automatically creates a new version every time you update a record. This means you can track all changes to your data and roll back to any previous version if needed. It's like having a complete history of all your data modifications, ensuring you never lose important information * (limited to 10 version)",
  },
  {
    question: "Can I use myJson for production applications?",
    answer: 
      "Absolutely! myJson is designed for both prototyping and production use. Many developers use it for live applications, dashboards, and data collection systems. Our API is reliable, fast, and scales with your needs. We provide real-time analytics to help you monitor performance and usage.",
  },
  {
    question: "What programming languages can I use with myJson?",
    answer: 
      "You can use any programming language that supports HTTP requests. Since myJson provides a standard REST API, it works with JavaScript, Python, PHP, Ruby, Java, C#, Go, and many others. We provide comprehensive documentation with code examples for popular languages.",
  },
  {
    question: "How do I get started with myJson?",
    answer: 
      "Getting started is simple: 1) Sign up for a free account, 2) Get your API key, 3) Start making API calls. You'll receive 500 free credits to begin. Check out our documentation for quick start guides and code examples to help you integrate myJson into your project.",
  },
];

export function Faqs() {
  return (
    <div className="">
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
        <div className="mx-auto max-w-4xl divide-y divide-gray-400/10">
          <h2 className="text-2xl font-bold leading-10 tracking-tight text-white">
            Frequently asked questions
          </h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-400/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-white">
                        <span className="text-base font-semibold leading-7">
                          {faq.question}
                        </span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmallIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          ) : (
                            <PlusSmallIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base leading-7 text-gray-200">
                        {faq.answer}
                      </p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
